import { Avatar, Box, Button, Typography, useTheme } from '@mui/material';
import { IconBolt } from '@tabler/icons-react';
import { useCreatePlanStore } from 'Application/store';
import { ThemeMode } from 'config';
import { FC, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import Loader from 'ui-component/Loader';
// import { useCreatePlanStore } from 'Application/store';
// import Loader from 'ui-component/Loader';

interface TravelPlanProps {
    data?: Array<Record<string, any>>; // Ensure data is optional and defaults to an empty array
}

export const TravelPlan: FC<TravelPlanProps> = ({ data = [] }) => {
    const navigate = useNavigate();
    const location = useLocation();
    // const { fetchedPlans, getPlan,isLoading,isError } = useCreatePlanStore();
    const { palette } = useTheme();
    const descriptionColor = palette.mode === ThemeMode.DARK ? 'text-gray-300' : 'text-gray-500';

    const navigateToPlan = (planID: number) => {
        navigate(`${location.pathname}/plan/${planID}`);
    };

    const { fetchedPlans, getPlan, isLoading, isError } = useCreatePlanStore();

    useEffect(() => {
        if (!data || data.length === 0) {
            getPlan(); // Fetch the plan data if it's not already available
        }
    }, [data, getPlan]);

    if (isLoading) {
        return <Loader />;
    }

    return (
        <Box
            sx={{
                width: '100%',
                display: 'grid',
                gridTemplateColumns: {
                    xs: '1fr', // 1 card per row on extra small screens
                    sm: '1fr 1fr', // 2 cards per row on small screens
                    lg: 'repeat(3, 1fr)' // 3 cards per row on large screens
                },
                gap: 2 // Gap between cards
            }}
        >
            {Array.isArray(data) && data.length > 0 ? (
                data.map((plan, index) => (
                    <Box key={index} className="border border-slate-200 rounded-md shadow-sm">
                        <Box id="top-section" className="p-3">
                            <Box className="flex flex-col items-center space-y-3 mb-6">
                                <Avatar className="bg-sky-50">
                                    <IconBolt className="text-sky-600" />
                                </Avatar>
                                <Typography className="font-medium text-base text-sky-700">{plan.name}</Typography>
                            </Box>
                            <Typography className={`font-medium text-sm text-center ${descriptionColor}`}>{plan.description}</Typography>
                        </Box>

                        <Box className="bg-slate-50 rounded-b-md p-6" id="bottom-section">
                            <Button
                                disableElevation
                                onClick={() => navigateToPlan(plan.planID)}
                                className="border bg-white border-gray-300 w-full"
                                variant="outlined"
                            >
                                <Typography className="text-slate-700 hover:text-sky-700">View Benefits</Typography>
                            </Button>
                        </Box>
                    </Box>
                ))
            ) : (
                <Typography>No plans available</Typography> // Fallback UI if data is empty or not an array
            )}
        </Box>
    );
};
